import { friendsAPI } from './baseService'

export const friendsService = {
  searchUsers: async (query) => {
    const response = await friendsAPI.get('/friends/search', {
      params: { query }
    })
    return response.data
  },

  sendFriendRequest: async (recipientId, message = '') => {
    const response = await friendsAPI.post('/friends/request', {
      recipientId,
      message
    })
    return response.data
  },

  acceptFriendRequest: async (friendshipId) => {
    const response = await friendsAPI.put(`/friends/request/${friendshipId}/accept`)
    return response.data
  },

  declineFriendRequest: async (friendshipId) => {
    const response = await friendsAPI.put(`/friends/request/${friendshipId}/decline`)
    return response.data
  },

  removeFriend: async (friendId) => {
    const response = await friendsAPI.delete(`/friends/remove/${friendId}`)
    return response.data
  },

  blockUser: async (userId) => {
    const response = await friendsAPI.put(`/friends/block/${userId}`)
    return response.data
  },

  getFriends: async (userId = null) => {
    const url = userId ? `/friends/list/${userId}` : '/friends/list'
    const response = await friendsAPI.get(url)
    return response.data
  },

  getPendingRequests: async () => {
    const response = await friendsAPI.get('/friends/requests/pending')
    return response.data
  },

  getSentRequests: async () => {
    const response = await friendsAPI.get('/friends/requests/sent')
    return response.data
  },

  updateFriendshipPermissions: async (friendshipId, permissions) => {
    const response = await friendsAPI.put(`/friends/permissions/${friendshipId}`, {
      permissions
    })
    return response.data
  }
}